import { ProjectModel } from '../../store/types';
import { SuSyApi } from '../susyApi';

export const getAllInvolvedUsersProjects = async (): Promise<
    ProjectModel[]
> => {
    const { data } = await SuSyApi.get(`/project/allInvolvedUsersProjects`);

    return data;
};

export const setSecondAttempt = async (
    projectId: string,
    secondAttemptStudentIds: Array<string>
): Promise<void> => {
    await SuSyApi.patch('/project/secondAttempt', {
        projectId,
        secondAttemptStudentIds,
    });
};

export const getProjects = async (
    projectIds: Array<string>
): Promise<Array<ProjectModel>> => {
    const { data } = await SuSyApi.post('/project/projects', projectIds);
    return data;
};
